import { isIconSizeToken } from "./isIconSizeToken";
import { type IconSize, type IconSizePercentage } from "./sizes";

const ICON_SIZE_PERCENTAGE_PATTERN = /^\d+(\.\d+)?%$/;

export function isIconSizePercentage(
  size: IconSize,
): size is IconSizePercentage {
  return typeof size === "string" && !isIconSizeToken(size);
}

export function isValidIconSizePercentage(size: string): boolean {
  return ICON_SIZE_PERCENTAGE_PATTERN.test(size);
}
